import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/components/Welcome'
import DailyReport from '@/components/DailyReport'

Vue.use(Router)

export default new Router({
  routes: [
    { name: 'Welcome', path: '/', component: Welcome, meta: { title: 'Welcome' } },
    { name: 'DailyReport', path: '/DailyReport/:action', component: DailyReport, meta: { title: 'DailyReport' }, props: true }
    // remaining routers are added dynamically in App.vue while creating menu
  ],
  mode: 'history'
})
